import { Action } from '@ngrx/store';
import { HoldingsRequestPayload, Holding, HoldingsFileRequestPayload } from './holdings.models';
import { DatesIntervalRequest, DatesInterval } from '../../global/interfaces';

export enum ActionTypes {
  LOAD_HOLDINGS_DATES = '[Holdings] Load Holdings Dates Action',
  LOAD_HOLDINGS_DATES_SUCCESS = '[Holdings] Load Holdings Dates Success Action',
  LOAD_HOLDINGS_DATES_FAILED = '[Holdings] Load Holdings Dates Failed Action',

  LOAD_HOLDINGS = '[Holdings] Load Holdings Data Action',
  LOAD_HOLDINGS_SUCCESS = '[Holdings] Load Holdings Data Success Action',
  LOAD_HOLDINGS_FAILED = '[Holdings] Load Holdings Data Failed Action',

  SET_HOLDINGS_YEAR_FILTER = '[Holdings] Set Holdings Year Filter Action',
  SET_HOLDINGS_MONTH_FILTER = '[Holdings] Set Holdings Month Filter Action',

  HOLDINGS_FILE_DOWNLOAD = '[Holdings] Holdings File Download Action',

  SET_HOLDINGS_ALLOCATION_TYPE = '[Holdings] Set Holdings Allocation Type Action',

  RESET_HOLDINGS_DATA = '[Holdings] Reset Holdings Data Action'
}

export class LoadHoldingsDatesAction implements Action {
  readonly type = ActionTypes.LOAD_HOLDINGS_DATES;

  public constructor(public payload: DatesIntervalRequest) {
  }
}

export class LoadHoldingsDatesSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_HOLDINGS_DATES_SUCCESS;

  public constructor(public payload: DatesInterval) {
  }
}

export class LoadHoldingsDatesFailedAction implements Action {
  readonly type = ActionTypes.LOAD_HOLDINGS_DATES_FAILED;

  public constructor(public payload: any) {
  }
}

export class LoadHoldingsAction implements Action {
  readonly type = ActionTypes.LOAD_HOLDINGS;

  public constructor(public payload: HoldingsRequestPayload) {
  }
}

export class LoadHoldingsSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_HOLDINGS_SUCCESS;

  public constructor(public payload: Holding[]) {
  }
}

export class LoadHoldingsFailedAction implements Action {
  readonly type = ActionTypes.LOAD_HOLDINGS_FAILED;

  public constructor(public payload: any) {
  }
}

export class SetHoldingsYearFilterAction implements Action {
  readonly type = ActionTypes.SET_HOLDINGS_YEAR_FILTER;

  public constructor(public payload: number) {
  }
}

export class SetHoldingsMonthFilterAction implements Action {
  readonly type = ActionTypes.SET_HOLDINGS_MONTH_FILTER;

  public constructor(public payload: number) {
  }
}

export class HoldingsFileDownloadAction implements Action {
  readonly type = ActionTypes.HOLDINGS_FILE_DOWNLOAD;

  public constructor(public payload: HoldingsFileRequestPayload) {
  }
}

export class SetHoldingsAllocationTypeAction implements Action {
  readonly type = ActionTypes.SET_HOLDINGS_ALLOCATION_TYPE;

  public constructor(public payload: string) {
  }
}

export class ResetHoldingsDataAction implements Action {
  readonly type = ActionTypes.RESET_HOLDINGS_DATA;
}

export type Actions =
  LoadHoldingsDatesAction |
  LoadHoldingsDatesSuccessAction |
  LoadHoldingsDatesFailedAction |
  LoadHoldingsAction |
  LoadHoldingsSuccessAction |
  LoadHoldingsFailedAction |
  SetHoldingsYearFilterAction |
  SetHoldingsMonthFilterAction |
  HoldingsFileDownloadAction |
  SetHoldingsAllocationTypeAction |
  ResetHoldingsDataAction;
